var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isloaded)?_c('div',{staticClass:"ReportPage"},[_c('Bookmarks',{attrs:{"token":_vm.token,"language":_vm.language}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }